import { useEffect, useRef } from 'react';

import { TAB_RETURN_DEDUPE_MS } from '../config';

// Coming back to this tab, e.g. from the template editor opened in another
// one, reported once per return.
export const useTabReturn = (onReturn: () => void) => {
  const onReturnRef = useRef(onReturn);
  const lastReturnRef = useRef(0);

  useEffect(() => {
    onReturnRef.current = onReturn;
  });

  useEffect(() => {
    const handleReturn = () => {
      const now = Date.now();
      if (
        document.visibilityState !== 'visible' ||
        now - lastReturnRef.current < TAB_RETURN_DEDUPE_MS
      ) {
        return;
      }
      lastReturnRef.current = now;
      onReturnRef.current();
    };
    window.addEventListener('focus', handleReturn);
    document.addEventListener('visibilitychange', handleReturn);
    return () => {
      window.removeEventListener('focus', handleReturn);
      document.removeEventListener('visibilitychange', handleReturn);
    };
  }, []);
};
